
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class BrandModel extends Model<BrandModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'shortName', type: 'string' },
		{ name: 'logo', type: 'number[]', isArray: true },
		{ name: 'productPlans', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public shortName: string;
	public logo: number[];
	public productPlans: ProductPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.shortName = '';
		this.logo = [];
		this.productPlans = [];
		
	}
	getProperties(){
		return BrandModel.classProperties;
	}
}

